module.exports = __webpack_public_path__ + "static/engineering-c207ba49e387d54b13af8df578ef1018.jpg";